module.exports = __webpack_public_path__ + "img/H02028-01.b118475b.jpg";